import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import './UserOnboardingPage.css';
import tooltip from "../../assets/images/questionTooltip.svg";
import SignUpUserHeader from "../../components/header/SignUpUserHeader";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { getRequest } from '../../api';
import { notification } from 'antd';
import { Countries } from "../../constants/constants.js";
import { getPlanDetails } from "../../api/password.js";
import { Col, Row } from "antd";

const ContactInfo = ({ onboardingData, setOnboardingData }) => {
  const [showEmailTooltip, setShowEmailTooltip] = useState(false);
  const [showPhoneTooltip, setShowPhoneTooltip] = useState(false);
  const [showTrustedTooltip, setShowTrustedTooltip] = useState(false);
  const [showLocationTooltip, setShowLocationTooltip] = useState(false);
  const [phone, setPhone] = useState(onboardingData.contactInfo?.phone || '');
  const [city, setCity] = useState(onboardingData.contactInfo?.city || '');
  const [country, setCountry] = useState(onboardingData.contactInfo?.country || '');
  const [address, setAddress] = useState(onboardingData.contactInfo?.address || '');
  const [postalCode, setPostalCode] = useState(onboardingData.contactInfo?.postalCode || '');
  const userId = localStorage.getItem("userid");

  const navigate = useNavigate();


  const handlePhoneChange = (value) => {
    setPhone(value);
  };

  const handleCountryChange = (event) => {
    setCountry(event.target.value);
  };

  const stateToSend = {
    address: address || "Unknown",
    postalCode: postalCode || "Unknown",
    city: city,
    country: country
  };

  const handleNext = async (event) => {

    event.preventDefault();
    const { contactEmail, trustedEmail } = event.target.elements;
    const selectedCountry = Countries.find(c => c.value === country);
    const countryLabel = selectedCountry ? selectedCountry.label : "";

    const contact = {
      contactEmail: contactEmail.value,
      phone,
      truetedEmail: trustedEmail.value,
      city,
      country: countryLabel,
    };
    let originalEmail;
    if (address) contact.address_street = address;
    if (postalCode) contact.postal_code = postalCode;
    try {
      const response = await getRequest('/user', userId);
      originalEmail = response.email;
    } catch (error) {
      console.error("Error Fetching User :", error);
    }
  
      if (originalEmail === contact.truetedEmail) {
        notification.error({ message: 'You cannot be added as trusted user to yourself.', duration: 10 });

      } else {

        setOnboardingData({
          ...onboardingData,
          contactInfo: {
            contactEmail: contactEmail.value,
            phone,
            truetedEmail: trustedEmail.value,
            city,
            country: countryLabel,
            ...(address && { address_street: address }),
            ...(postalCode && { postal_code: postalCode }),
          },
        });

        localStorage.setItem('contactInfo', JSON.stringify(contact));
        try {
          const stripeResponse = await getPlanDetails();
      
          if (stripeResponse.status === 404) {
            navigate('/subs', { state: stateToSend });
          } else {
            navigate('/onboarding/get-to-know-you');
          }
        } catch (error) {
          console.error("Error fetching Stripe plan details:", error);
          navigate('/subs', { state: stateToSend });
        }
    }
  };

  const contactInfo = onboardingData.contactInfo || {};

  const handleBack = () => {
    navigate('/onboarding/personal-info');
  };

  return (
    <Row className="welcome-onboarding-row" style={{ background: "#fefcfe" }}>
      <Col lg={24}>
        <SignUpUserHeader />
      </Col>
      <Row gutter={24} className="welcome-onboarding-row-card-container">
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={24}
          className="welcome-onboarding-inner-content-col"
        >
          <div className="onboarding-step">
            <h1>Contact Information</h1>
            <form onSubmit={handleNext}>
              <label htmlFor="contactEmail">
                Email Address <i className="required-input">*</i>
                <img
                  src={tooltip}
                  alt="tooltip"
                  className="tooltip-icon"
                  onMouseOver={() => setShowEmailTooltip(true)}
                  onMouseOut={() => setShowEmailTooltip(false)}
                />
                {showEmailTooltip && (
                  <div className="tooltip">
                    <p>
                      <strong>Why do we need this?</strong>
                    </p>
                    <p>
                      Don't worry we won't use this to send you needless emails.
                      Your email address will act as your username. If you
                      change device you can use this to log into the same
                      account, without having to set it up again.
                    </p>
                  </div>
                )}
              </label>
              <input
                name="contactEmail"
                type="email"
                placeholder="Contact Email"
                defaultValue={contactInfo.contactEmail}
                required
              />
              <label htmlFor="phone">
                Phone Number
                <img
                  src={tooltip}
                  alt="tooltip"
                  className="tooltip-icon"
                  onMouseOver={() => setShowPhoneTooltip(true)}
                  onMouseOut={() => setShowPhoneTooltip(false)}
                />
                {showPhoneTooltip && (
                  <div className="tooltip">
                    <p>
                      <strong>Why do we need this?</strong>
                    </p>
                    <p>
                      Adding your phone number allows for retrieval of your
                      account if you cannot access your email or forget your
                      password. It also acts as an added layer of security to
                      protect your account.
                    </p>
                  </div>
                )}
              </label>
              <PhoneInput
                country={"gb"}
                value={phone}
                onChange={handlePhoneChange}
                className="mb-15-px"
                inputProps={{
                  name: "phone",
                  autoFocus: true,
                  placeholder: "Phone Number",
                }}
              />
              <label htmlFor="location">
                Enter your Location 
                <img
                  src={tooltip}
                  alt="tooltip"
                  className="tooltip-icon"
                  onMouseOver={() => setShowLocationTooltip(true)}
                  onMouseOut={() => setShowLocationTooltip(false)}
                />
                {showLocationTooltip && (
                  <div className="tooltip">
                    <p>
                      <strong>Why do we need this?</strong>
                    </p>
                    <p>
                      This lets us better tailor our features to you. Get advice
                      and notifications that are relevant to you based on your
                      location.
                    </p>
                  </div>
                )}
              </label>
              <div className="location-fields">
                <input
                  type="text"
                  name="city"
                  placeholder="City"
                  value={city}
                  onChange={(e) => setCity(e.target.value)}
                  className="location-input"
                />
                <select
                  name="country"
                  value={country}
                  onChange={handleCountryChange}
                  className="location-input"
                >
                  <option value="" disabled>
                    Select your country
                  </option>
                  {Countries.map((country) => (
                    <option key={country.value} value={country.value}>
                      {country.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="location-fields">
                <input
                  type="text"
                  name="address"
                  placeholder="Address"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  className="location-input"
                />
                <input
                  type="text"
                  name="postalCode"
                  placeholder="Postal Code"
                  value={postalCode}
                  onChange={(e) => setPostalCode(e.target.value)}
                  className="location-input"
                />
              </div>
              <label htmlFor="trustedEmail">
                Would you like to add a trusted contact? (Optional)
                <img
                  src={tooltip}
                  alt="tooltip"
                  className="tooltip-icon"
                  onMouseOver={() => setShowTrustedTooltip(true)}
                  onMouseOut={() => setShowTrustedTooltip(false)}
                />
                {showTrustedTooltip && (
                  <div className="tooltip">
                    <p>
                      <strong>Why do we need this?</strong>
                    </p>
                    <p>
                      It is completely up to you whether you want to add a
                      trusted contact. By opting to do so, you can choose if you
                      would like to share your conversations and use time on the
                      MyFriend app with a loved one. Your choice can be changed
                      at any time in settings.
                    </p>
                  </div>
                )}
              </label>
              <input
                name="trustedEmail"
                type="email"
                placeholder="Trusted Contact Email"
                defaultValue={contactInfo.trustedEmail}
              />
              <div className="button-container">
                <button
                  type="button"
                  onClick={handleBack}
                  className="back-button"
                >
                  Back
                </button>
                <button type="submit">Next</button>
              </div>
            </form>
          </div>
        </Col>
      </Row>
    </Row>
  );
};

export default ContactInfo;